export default {
  market: '/',
  details: 'categoria/:category/:id',
  productDetail: 'producto/:id',
  cart: '/carrito',
  //recieve: '/recibir/:id',
  //confirmation: '/confirmacion/:id',
  //newOrder: '/nueva',
};
